interface State {
  baseUrl: string
}
const state: State = {
  baseUrl: window.localStorage.getItem('baseUrl') || ''
}

const mutations = {
  setBaseUrl(state: State, baseUrl: string) {
    state.baseUrl = baseUrl
    window.localStorage.setItem('baseUrl', baseUrl || '')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
